export default "__VITE_ASSET__3da4eb16__"